/**
 * Checks whether a single value should be treated as empty.
 */
export function isEmpty(val: unknown): boolean {
  if (val === null || val === undefined) return true;
  if (typeof val === 'string') return val.trim() === '';
  // For non-string types, any value counts as "has value"
  return false;
}

/**
 * Checks whether all specified fields in a row are empty.
 *
 * A field is considered empty when its value is `null`, `undefined`,
 * or an empty string after trimming.
 *
 * @param row - Source object containing the fields to check.
 * @param fields - List of field names to validate.
 * @returns `true` when every specified field is empty, otherwise `false`.
 */
export function areFieldsEmpty(row: Record<string, unknown>, fields: string[]): boolean {
  return fields.every((field) => isEmpty(row[field]));
}
